import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProductCard } from '../../pages/Home/homeData';

interface RecentViewsState {
  items: ProductCard[];
}

const initialState: RecentViewsState = {
  items: [],
};

const recentViewsSlice = createSlice({
  name: 'recentViews',
  initialState,
  reducers: {
    addRecentView: (state, action: PayloadAction<ProductCard>) => {
      // Remove it if it already exists so we can move it to the front
      state.items = state.items.filter((item) => item.id !== action.payload.id);
      
      // Add to front
      state.items.unshift(action.payload);
      
      // Keep only the last 15 items
      if (state.items.length > 15) {
        state.items.pop();
      }
    },
    clearRecentViews: (state) => {
      state.items = [];
    }
  },
});

export const { addRecentView, clearRecentViews } = recentViewsSlice.actions;
export default recentViewsSlice.reducer;
